/* eslint-disable no-throw-literal */
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
(() => {
  if (!customElements.get("rebuy-button")) {
    class RebuyButton extends HTMLElement {
      connectedCallback() {
      
        this.cart = document.querySelector("cart-drawer");

        this.buyAgainBtn = this.querySelector("button");

        this.orderJSON = this.querySelector(".js-order-line-items");

        if (!this.orderJSON || !this.cart) {
          return;
        }

        this.order = JSON.parse(this.orderJSON.innerHTML);

        this.items = [];
        this.order.forEach((item) => {
          this.items.push({
            id: item.variant_id,
            quantity: item.quantity,
            properties: {
              _moduleClassification: item.module_classification ?? null,
              _categories: this.categories
            },
          });
        });

        this.formData = {
          items: this.items,
        }; 

        this.buyAgainBtn.addEventListener("click", async () => {
          if(this.getAttribute("has-no-available-item")){
            showErrorBox(this.dataset.defaulterror,this,"buy-button__error-box--show","buy-button__error-box--hide");   
            setTimeout(() => {
              this.querySelector(".box").classList.remove("buy-button__error-box--show");
              this.querySelector(".box").classList.add("buy-button__error-box--hide");
            }, 3000);
          }else{
            this.cart.addToCart(this.formData).then((err) => {
              if(err === false){
                showErrorBox(this.dataset.defaulterror,this,"buy-button__error-box--show","buy-button__error-box--hide");   
                setTimeout(() => {
                  this.querySelector(".box").classList.remove("buy-button__error-box--show");
                  this.querySelector(".box").classList.add("buy-button__error-box--hide");
                }, 3000);
              }
            })
          }
        });
      }
    }

    customElements.define("rebuy-button", RebuyButton);
  }
})();